import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import * as moment from 'moment';
import { TamasAlunoService } from '../tamas-aluno.service';

@Component({
  selector: 'app-me-dietas',
  templateUrl: './me-dietas.component.html',
  styleUrls: ['./me-dietas.component.css']
})
export class MeDietasComponent implements OnInit {

  existeTreino: boolean = false;
  hideCL: boolean = false;
  arrDietas: any[] = [];
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService) { }

  ngOnInit() {
    this.hideCL = false;
    this.existeTreino = false;
    this.carregarDietas();

  }

  carregarDietas() :void{
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.listarDietas(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        this.arrDietas = qRes['arrDietas'];
        if(this.arrDietas.length > 0){
          this.existeTreino = true;
        }
      }
    })

  }
  goDieta(idDieta: any) :void{
    //this.router.navigate(['me/dieta/' + idDieta + "/0"]);
    var qds = new Date().getDay();
    var diahj = moment(new Date()).format("DD/MM/YYYY");
    console.log(qds);
    console.log(diahj);
    console.log( diahj.replace(/\//g,'-'));
    this.tmaService.paginaAnterior = "dietas";
    this.router.navigate(['me/cardapio/' + idDieta + '/' + qds + '/' + diahj.replace(/\//g,'-') ]);
  }
  
  goPesquisar(){
    this.router.navigate(['/pesquisar']);
    
  }
}
